import { Container } from '@material-ui/core';
import Page from '../components/Page';
import ClientFull from '../components/clients/ClientFull';

export default function RegisterClient() {
  return (
    <Page title="Dashboard: Register | getCred-UI">
      <Container>
        <ClientFull />
      </Container>
    </Page>
  );
}
